import { useState, useEffect } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { captureException, toError } from '../../internal/ravenUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function InitWrapper({
  appId,
  portalId,
  onInit,
  children
}) {
  const [initState, setInitState] = useState(onInit ? {
    status: 'loading'
  } : {
    status: 'ready',
    resolvedProps: {}
  });
  useEffect(() => {
    if (!onInit) return;
    let isMounted = true;
    const runInit = async () => {
      try {
        setInitState({
          status: 'loading'
        });
        const resolvedProps = await onInit({
          appId,
          portalId
        });
        if (isMounted) {
          setInitState({
            status: 'ready',
            resolvedProps
          });
        }
      } catch (err) {
        captureException(new Error('onInit hook failed', {
          cause: toError(err)
        }), {
          extra: {
            appId,
            portalId
          }
        });
        if (isMounted) {
          setInitState({
            status: 'error',
            message: err instanceof Error ? err.message : 'Failed to initialize component'
          });
        }
      }
    };
    void runInit();
    return () => {
      isMounted = false;
    };
  }, [appId, portalId, onInit]);
  if (initState.status === 'loading') {
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      paddingBlock: "300",
      children: [/*#__PURE__*/_jsx(LoadingSpinner, {}), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(Text, {
          children: "Loading..."
        })
      })]
    });
  }
  if (initState.status === 'error') {
    return /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      titleText: "Initialization Error",
      children: /*#__PURE__*/_jsx(View, {
        paddingBlock: "200",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(Text, {
          children: initState.message
        })
      })
    });
  }
  if (initState.status === 'ready') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children(initState.resolvedProps)
    });
  }
  return null;
}